// ─────────────────────────────────────────────────────────────────────────────
// HeroEditor.tsx — ContentSectionEditPageCareer
// ─────────────────────────────────────────────────────────────────────────────
import React, { useRef } from 'react';
import { HeroSection, PrimaryButton } from './types';
import { LabelRow, SplitRow, DraftTextField } from './components';

const HeroEditor: React.FC<{
  data:     HeroSection;
  onChange: (v: HeroSection) => void;
}> = ({ data, onChange }) => {
  // Frozen on mount — never mutated
  const orig = useRef(data);

  const set    = (p: Partial<HeroSection>) => onChange({ ...data, ...p });
  const setBtn = (p: Partial<PrimaryButton>) =>
    onChange({ ...data, primaryButton: { ...data.primaryButton, ...p } });

  return (
    <>
      <LabelRow label="Main title" required />
      <SplitRow currentText={orig.current.headline}>
        <DraftTextField
          placeholder="Main title"
          onChange={v => set({ headline: v })}
        />
      </SplitRow>

      <LabelRow
        label="Primary button"
        toggle={{
          checked:  data.primaryButton.visible,
          onChange: v => setBtn({ visible: v }),
        }}
      />
      <SplitRow currentText={orig.current.primaryButton.label}>
        <DraftTextField
          placeholder="Text button"
          onChange={v => setBtn({ label: v })}
        />
      </SplitRow>
    </>
  );
};

export default HeroEditor;